// extracted by mini-css-extract-plugin
export default {"footerBg":"s-z","footerTopLinks":"t-z","footerFeedback":"u-z","footerSocial":"v-z","footerLegalLinks":"w-z","footerIconCards":"x-z","footerBotCopy":"y-z"};